export const tasksAssignmentKeys = {
  all: ['tasks-assignments'] as const,
  lists: () => [...tasksAssignmentKeys.all, 'list'] as const,
  list: (workspaceId?: number | null) => [...tasksAssignmentKeys.lists(), workspaceId ?? null] as const,
}
